import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import OsPoiService from "../services/OsPoiService";

const useOsPoiService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new OsPoiService(client);
  }, [client]);

  return service;
};

export default useOsPoiService;
